import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaFileInvoiceDollar } from 'react-icons/fa';
import './PublicFooter.scss';

const PublicFooter = ({ compact }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn || "");

  // Don't show public footer if logged in (usually the main app has its own footer)
  if (isLoggedIn) return null;

  return (
    <footer className={`public-footer ${compact ? 'public-footer--compact' : ''}`}>
      <div className="footer-container">
        {/* Brand Column */}
        <div className="footer-brand">
          <Link to="/" className="brand-link">
            <div className="brand-icon">
              <FaFileInvoiceDollar />
            </div>
            <span className="brand-name">ChallanBook</span>
          </Link>
          <p className="brand-desc">
            The complete GST invoicing and billing solution for Indian small businesses. 
            Simple, secure, and professional.
          </p>
        </div>

        {/* Product Column */}
        <div className="footer-nav-col">
          <h4>Product</h4>
          <ul>
            <li><a href="/#features">Features</a></li>
            <li><a href="/#pricing">Pricing</a></li>
            <li><Link to="/signup">Get Started</Link></li>
          </ul>
        </div>

        {/* Legal Column */}
        <div className="footer-nav-col">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Support Column */}
        <div className="footer-nav-col">
          <h4>Support</h4>
          <ul>
            <li><a href="tel:9480723193">Call: +91 9480723193</a></li>
            <li><a href="mailto:support@challanbook.com">Email: support@challanbook.com</a></li>
            <li><a href="https://www.obaps.in/contact.php" target="_blank" rel="noreferrer">Contact Us</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">&copy; {new Date().getFullYear()} ChallanBook. All rights reserved.</p>
        
        <div className="footer-meta">
          <span className="version">Version 1.0.0</span>
          <span className="powered-by">
            Powered by <a href="https://obaps.in" target="_blank" rel="noopener noreferrer">OBAPS</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
